interface MarkdownTextProps {
  content: string;
  className?: string;
}

function escapeHtml(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function formatInline(value: string) {
  const escaped = escapeHtml(value);
  return escaped
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/_(.+?)_/g, '<em>$1</em>');
}

function renderMarkdown(text: string) {
  const normalized = text.replace(/\r\n?/g, '\n');
  const blocks = normalized.split(/\n{2,}/);
  const htmlParts: string[] = [];

  blocks.forEach((block) => {
    const trimmed = block.trim();
    if (!trimmed) return;

    const lines = trimmed.split('\n');
    const isList = lines.every((line) => /^-\s+/.test(line.trim()));

    if (isList) {
      htmlParts.push('<ul>');
      lines.forEach((line) => {
        const content = line.replace(/^-\s+/, '');
        htmlParts.push(`<li>${formatInline(content)}</li>`);
      });
      htmlParts.push('</ul>');
    } else {
      const formattedLines = lines.map((line) => formatInline(line));
      htmlParts.push(`<p>${formattedLines.join('<br />')}</p>`);
    }
  });

  return htmlParts.join('');
}

export function MarkdownText({ content, className }: MarkdownTextProps) {
  const html = renderMarkdown(content);

  return (
    <div
      className={`markdown-text ${className || ''}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
